import type { IconNode } from '../types';

/**
 * @name folder-bookmark
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgNnY3Ljc1MWEuMjUuMjUgMCAwMC40MDcuMTk1bDIuMjgtMS44MzRhLjUuNSAwIDAxLjYyNyAwbDIuMjggMS44MzRhLjI1LjI1IDAgMDAuNDA2LS4xOTVWNiIgLz4KICA8cGF0aCBkPSJNMjAgMjBhMiAyIDAgMDAyLTJWOGEyIDIgMCAwMC0yLTJoLTcuOWEyIDIgMCAwMS0xLjY5LS45TDkuNiAzLjlBMiAyIDAgMDA3LjkzIDNINGEyIDIgMCAwMC0yIDJ2MTNhMiAyIDAgMDAyIDJ6IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/folder-bookmark
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const FolderBookmark: IconNode = [
  [
    'path',
    {
      d: 'M12 6v7.751a.25.25 0 00.407.195l2.28-1.834a.5.5 0 01.627 0l2.28 1.834a.25.25 0 00.406-.195V6',
    },
  ],
  [
    'path',
    {
      d: 'M20 20a2 2 0 002-2V8a2 2 0 00-2-2h-7.9a2 2 0 01-1.69-.9L9.6 3.9A2 2 0 007.93 3H4a2 2 0 00-2 2v13a2 2 0 002 2z',
    },
  ],
];

export default FolderBookmark;
